import { mostRecentParallelJobs, useJobsForStep } from "~/components/build/Show/lib/BuildContext";
import { CommandStep } from "~/lib/pipeline";
import { sortByState } from "~/components/build/Show/components/TableView/TableCell";
import { twMerge } from "tailwind-merge";
import classNames from "classnames";
import { JobPillLink } from "~/components/build/Show/components/StepDrawer/JobPillLink";
import { CommandJob } from "~/components/build/Show/lib/types";

interface Props {
  step: CommandStep;
  jobs?: CommandJob[];
}

export const ParallelStepDetails = ({ step, jobs }: Props) => {
  const parallelJobs = jobs || useJobsForStep<CommandJob>(step.uuid);
  const recentParallelJobs = mostRecentParallelJobs(parallelJobs).sort(sortByState("asc"));

  return (
    <div className="flex min-w-0 flex-auto flex-col gap-2 pb-2">
      <div
        className="grid-col-dense grid gap-1.5"
        style={{
          // 75px is the minimum width that seems to handle 1000+ job counts
          gridTemplateColumns: "repeat(auto-fill, minmax(70px, 1fr))",
        }}
      >
        {recentParallelJobs.map((job) => {
          const index = job.parallelGroupIndex || 0;
          return (
            <JobPillLink
              job={job}
              key={job.id}
              className="text-inherit hover:text-inherit focus:text-inherit"
            >
              <span
                className={twMerge(
                  classNames(
                    "white small tabular-numerals text-charcoal-700 flex flex-1 justify-center rounded border border-slate-500 bg-white px-1",
                    {
                      "border-lime-500": job.state === "finished" && job.passed,
                      "border-red-500": job.state === "finished" && !job.passed,
                      "border-orange-500": job.state === "running",
                    },
                  ),
                )}
              >
                {index + 1}
              </span>
            </JobPillLink>
          );
        })}
      </div>
    </div>
  );
};
